import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';

import { FullscreenViewExportService, FullscreenViewService } from '../../services';

@Directive({ selector: '[fullscreenGlobalExport]' })
export class FullscreenGlobalExportDirective implements OnInit {
    @Input('fullscreenGlobalExportExceptions') exceptions: unknown[] = [];

    constructor(
        private container: ViewContainerRef,
        private template: TemplateRef<unknown>,
        private fullscreenViewService: FullscreenViewService,
        private exportService: FullscreenViewExportService,
    ) {}

    ngOnInit() {
        const { isFullscreenView } = this.fullscreenViewService;
        const hasExceptions = this.exceptions.some(Boolean);

        if (isFullscreenView && !hasExceptions) {
            this.exportService.setContainer(this.container);
        } else {
            this.container.createEmbeddedView(this.template);
        }
    }
}
